import {
  channelDivisionMap,
  languageDivisionMap,
  whiteList,
} from '@op/constants/request';

const addChannel = (channelList: Array<string>) => {
  const result: Array<string> = [];
  try {
    channelList.forEach(item => {
      result.push(item);
      // 获取分裂值
      const divisionValue = channelDivisionMap[item];
      // 分裂值存在就添加
      if (divisionValue) {
        result.push(...divisionValue);
      }
    });
  } catch (error) {}

  return result;
};

const addLanguages = (languageList: Array<string>) => {
  const result: Array<string> = [];
  try {
    languageList.forEach(item => {
      result.push(item);
      // 获取分裂值
      const divisionValue = languageDivisionMap[item];
      // 分裂值存在就添加
      if (divisionValue) {
        result.push(...divisionValue);
      }
    });
  } catch (error) {}

  return result;
};

const dealwithChannelParams = (params: any) => {
  let data: any = null;
  try {
    data = JSON.parse(JSON.stringify(params));
  } catch (error) {
    // console.log(error);
  }

  // 这里指定部分参数才需要做这些处理
  const keys = ['channel_social', 'channel', 'channels', 'exclude_channels'];
  keys.forEach(key => {
    if (data?.[key]) {
      data[key] = addChannel(data[key]);
    }
  });

  return data;
};

const dealwithLanguageParams = (params: any) => {
  let data: any = null;
  try {
    data = JSON.parse(JSON.stringify(params));
  } catch (error) {
    // console.log(error);
  }

  // 这里指定部分参数才需要做这些处理
  const keys = ['languages', 'language', 'except_language'];
  keys.forEach(key => {
    if (data?.[key] && Array.isArray(data?.[key])) {
      data[key] = addLanguages(data[key]);
    }
  });

  return data;
};

export const dealwithParams = (config: any) => {
  const { url, data } = config;
  let realData = data;
  if (!whiteList.includes(url)) {
    realData = dealwithChannelParams(realData);
    realData = dealwithLanguageParams(realData);
  }
  return { ...config, data: realData };
};
